import { motion } from "framer-motion";
import { IMG } from "@/lib/assets";

const EASE = [0.16, 1, 0.3, 1];

const CREDENTIALS = [
  "Master Hypnotherapist", "Rapid Transformational Therapist", "Certified Therapist",
  "Past Life Regressionist", "Quantum Healer", "Reiki Practitioner",
  "Angel Investor", "Priestess of the Red Rose Lineage",
];

const STATS = [
  { n: "14", l: "years of practice" },
  { n: "19", l: "sold-out retreats" },
  { n: "13+", l: "countries reached" },
];

const fade = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE, delay: i * 0.08 } }),
};

export const Bio = () => {
  return (
    <section data-testid="bio-section" className="bg-cream py-24 md:py-36">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <p className="font-script text-peach-deep text-4xl md:text-5xl leading-none mb-12">who made this for you</p>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
          {/* Portrait */}
          <motion.div
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1, ease: EASE }}
            className="lg:col-span-5 lg:sticky lg:top-24"
          >
            <div className="relative overflow-hidden rounded-[2rem]">
              <img src={IMG.bio} alt="J" className="w-full h-[520px] md:h-[660px] object-cover object-[center_20%]" />
            </div>
            <span className="mt-4 block font-script text-6xl text-peach-deep leading-none">j muenz</span>
          </motion.div>

          {/* Copy */}
          <div className="lg:col-span-7">
            <motion.p
              variants={fade} custom={0} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="font-display font-black text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink"
            >
              Fourteen years extracting the extraordinary from women who already have it in them.
            </motion.p>

            <motion.p
              variants={fade} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="mt-10 text-lg md:text-xl font-light leading-relaxed text-ink-muted max-w-2xl"
            >
              J holds a degree in intercultural communication, has appeared on television and radio, secured a
              book deal, and has coached thousands of women across more than 13 countries. Her businesses span
              multiple industries, built to multiple six figures.
            </motion.p>

            <motion.p
              variants={fade} custom={1.3} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="mt-8 font-display font-medium text-2xl md:text-[1.9rem] leading-[1.35] text-ink border-l-4 border-rose pl-7 max-w-2xl"
            >
              But the credential that matters most for this meditation is this. J works at the level of the
              subconscious landscape, the patterns underneath the patterns, the beliefs and stories that live
              below the surface in brilliant women who have built extraordinary things and still feel like their
              body is working against them. She sees what some practitioners miss, and she designed this
              meditation from that exact depth.
            </motion.p>

            <div className="mt-12 flex flex-wrap gap-x-3 gap-y-3">
              {CREDENTIALS.map((c, i) => (
                <motion.span
                  key={c} variants={fade} custom={i * 0.4} initial="hidden" whileInView="show" viewport={{ once: true }}
                  className="rounded-full bg-blush px-5 py-2 text-sm font-medium text-ink"
                >
                  {c}
                </motion.span>
              ))}
            </div>

            <div className="mt-14 grid grid-cols-3 gap-8 border-t-2 border-peach pt-10 max-w-2xl">
              {STATS.map((s, i) => (
                <motion.div key={s.l} variants={fade} custom={i * 0.5} initial="hidden" whileInView="show" viewport={{ once: true }}>
                  <div className="font-display font-black text-5xl md:text-6xl text-peach-deep">{s.n}</div>
                  <div className="mt-2 text-sm text-ink-muted font-light">{s.l}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bio;
